import React, {
  useEffect,
  useCallback,
  useState,
  useRef,
  useContext,
} from 'react';
import { firestore } from '../firebase/firebase';
import { makeStyles } from '@material-ui/core/styles';
import { DataGrid } from '@material-ui/data-grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import {
  // BrowserRouter as Router,
  // Switch,
  Route,
  // Link,
  // useHistory,
  Redirect,
  useParams,
} from 'react-router-dom';

import { UserContext } from '../providers/UserProvider';

import { Button } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';

import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

function BookableSlots() {
  const { user } = useContext(UserContext);
  const [store, setStore] = useState(null);
  const isMounted = useRef(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const snackbars = {
    saveSuccess: {
      text: "Ändringar sparade",
      severity: 'success',
    },
    saveFailure: {
      text: "Kunde inte spara",
      severity: 'error',
    }
  }
  const snackbar = useRef();
  const [day, setDay] = useState('monday');
  const days = [
    {
      id: 'monday',
      name: 'Måndag',
    },
    {
      id: 'tuesday',
      name: 'Tisdag',
    },
    {
      id: 'wednesday',
      name: 'Onsdag',
    },
    {
      id: 'thursday',
      name: 'Torsdag',
    },
    {
      id: 'friday',
      name: 'Fredag',
    },
    {
      id: 'saturday',
      name: 'Lördag',
    },
    {
      id: 'sunday',
      name: 'Söndag',
    },
  ];
  const [slots, setSlots] = useState([]);
  const lastSlotId = useRef(0);
  let { storeId } = useParams();
  storeId = useRef(storeId);

  const getStore = useCallback(async () => {
    try {
      const storeSnapshot = await firestore
        .collection('stores')
        .doc(storeId.current)
        .get();

      if (storeSnapshot.exists) {
        const data = storeSnapshot.data();
        isMounted.current && setStore({
          ref: storeSnapshot.ref,
          ...data
        });
      }
    } catch (error) {
      console.error(error);
    }
  }, [storeId]);

  const getSlots = useCallback(async () => {
    try {
      const bookableSnapshot = await firestore
        .collection('stores')
        .doc(storeId.current)
        .collection('bookable')
        .doc(day)
        .get();
      const slots = [];
      let count = 0;
      if (bookableSnapshot.exists) {
        const data = bookableSnapshot.data();
        data?.slots?.forEach((slot) => {
          slots.push({
            id: `fetched-${day}-${slot.time}-${count}`,
            ...slot,
          });
          count++;
        });
      }
      setSlots(slots);
    } catch (error) {
      console.error(error);
    }
  }, [storeId, day]);

  useEffect(() => {
    isMounted.current = true;
    getStore();

    return (
      () => {
        isMounted.current = false;
      }
    );
  }, [getStore]);

  useEffect(() => {
    getSlots();
  }, [getSlots]);

  const handleDayChange = (event) => {
    const theDay = event.target.value;
    setDay(theDay);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  }

  const handleSave = async () => {
    const slotsToSave = slots.map((slot) => (
      {
        time: slot.time,
        max: Number.parseInt(slot.max),
      }
    ));
    try {
      await firestore
        .collection('stores')
        .doc(storeId.current)
        .collection('bookable')
        .doc(day)
        .set({
          slots: slotsToSave,
          storeName: store ? store.name : "",
          storeRef: store ? store.ref : null,
        },
          {
            merge: true,
          }
        );
      snackbar.current = snackbars.saveSuccess;
    }
    catch (error) {
      console.error(error);
      snackbar.current = snackbars.saveFailure;
    }
    setSnackbarOpen(true);
  };

  const handleTimeChange = (event, rowIndex) => {
    const updatedSlots = slots;
    updatedSlots[rowIndex] = {
      ...updatedSlots[rowIndex],
      time: event.target.value,
    };
    setSlots([...updatedSlots]);
  };

  const handleMaxChange = (event, rowIndex) => {
    const updatedSlots = slots;
    updatedSlots[rowIndex] = {
      ...updatedSlots[rowIndex],
      max: Number.parseInt(event.target.value),
    };
    setSlots([...updatedSlots]);
  };

  const handleAddSlot = () => {
    const slot = {
      id: lastSlotId.current,
      time: "",
      max: 10,
    };
    setSlots(
      [
        ...slots,
        slot,
      ]
    );
    lastSlotId.current++;
  };

  const handleDeleteSlot = (event, rowIndex) => {
    const theSlots = slots;
    theSlots.splice(rowIndex, 1);
    setSlots([...theSlots]);
  };

  const classes = useStyles();

  const columns = [
    {
      field: "time",
      headerName: "Tid",
      width: 250,
      renderCell: (params) => {
        return (
          <TextField
            id="time"
            // label="Tid"
            type="time"
            variant='standard'
            defaultValue={params.row.time}
            className={classes.textField}
            InputProps={{ classes: { input: classes.input } }}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              step: 300, // 5 min
            }}
            onChange={e => handleTimeChange(e, params.rowIndex)}
          />
        );
      },
    },
    {
      field: "max",
      headerName: "Max platser",
      width: 250,
      renderCell: (params) => {
        return (
          <TextField
            id="max"
            type="step"
            variant='standard'
            defaultValue={params.row.max}
            className={classes.textField}
            InputProps={{ classes: { input: classes.input } }}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              step: 1,
            }}
            onChange={e => handleMaxChange(e, params.rowIndex)}
          />
        );
      },
    },
    {
      field: "delete",
      renderCell: (params) => {
        return (
          <IconButton onClick={e => handleDeleteSlot(e, params.rowIndex)}>
            <DeleteIcon />
          </IconButton>
        );
      },
    },
  ];

  return (
    <Route
      render={() =>
        user.accessLevel === 10 ? (
          <div style={{ textAlign: "left" }}>
            <Snackbar
              open={snackbarOpen}
              autoHideDuration={4000}
              onClose={handleSnackbarClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              style={{ marginLeft: 100, marginTop: 50 }}
            >
              <Alert
                onClose={handleSnackbarClose}
                severity={snackbar.current?.severity}>
                {snackbar.current?.text}
              </Alert>
            </Snackbar>
            <Typography
              component="h1"
              variant="h5"
              color="primary"
              style={{ textAlign: "left", marginBottom: 0 }}
            >
              Populeringsinställningar
            </Typography>
            <Typography
              component="h2"
              variant="body1"
              color="primary"
              style={{ textAlign: "left", marginBottom: 30 }}
            >
              {store?.name}
            </Typography>

            <Select
              labelId="select-day"
              id="select-day"
              value={day}
              onChange={handleDayChange}
              label="Dag"
              variant='filled'
            >
              {days.map((day) => {
                return (
                  <MenuItem
                    value={day.id}
                    key={day.id}
                  >
                    {day.name}
                  </MenuItem>
                );
              })}
            </Select><br />

            <Button
              variant="outlined"
              color="primary"
              style={{
                marginTop: 9,
                marginRight: 30,
                marginLeft: 0,
                marginBottom: 20,
              }}
              onClick={handleAddSlot}
              startIcon={<AddIcon />}
            >
              Lägg till tid
            </Button>
            <Button
              variant='contained'
              color="primary"
              style={{
                marginTop: 9,
                marginLeft: 0,
                marginBottom: 20,
              }}
              onClick={handleSave}
              startIcon={<SaveIcon />}
            >
              Spara
            </Button>
            <Paper className={classes.paper}>
              <div
                style={{ height: 400, width: "100%" }}
                className={classes.root}
              >
                <DataGrid
                  columns={columns}
                  rows={slots}
                  pageSize={50}
                />

              </div>
            </Paper>
          </div>
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
}

export default BookableSlots;

const useStyles = makeStyles((theme) => ({
  root: {
    "& div.MuiDataGrid-row": {
      //   cursor: "pointer",
    },
  },
  seeMore: {
    marginTop: theme.spacing(3),
    table: {
      minWidth: 650,
    },
  },
  searchForm: {
    width: "100%",
    marginBottom: 40,
  },
  searchInput: {
    width: "50%",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  formControl: {
    marginRight: theme.spacing(1),
    width: 150,
    marginBottom: 30,
    // textAlign: 'left',
  },
  ul: {
    marginBottom: 50,
    "& li": {
      marginBottom: 10,
    },
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    // width: 200,
  },
  input: {
    height: 'auto',
  },
}));
